import axios from 'axios'

const base = process.env.VUE_APP_API_BASE || ''

const http = axios.create({
  baseURL: base,
  timeout: 20000
})

http.interceptors.response.use(
  (res) => {
    const d = res.data
    if (d && d.code !== 0 && d.code !== undefined) {
      return Promise.reject(d)
    }
    return d
  },
  (err) => Promise.reject(err)
)

export function cashierInit(params) {
  return http.get('/api/v1/cashier/init', { params })
}

export function cashierStatus(params) {
  return http.get('/api/v1/cashier/status', { params })
}
